module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABIAgMAAAB94riKAAAACVBMVEUAOJf////XKCjvr6buAAAAMElEQVR4AWOAgtBVq0IZUMAQlhmVGZUJhQCQDCqgsswqXGBoytAr3IZjShyVGZUBAJvrPChC77B4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/country_flags/is.png
// module id = +XXL
// module chunks = 0